import { render, staticRenderFns } from "./userTeamRankings.vue?vue&type=template&id=44341242&scoped=true&"
import script from "./userTeamRankings.vue?vue&type=script&lang=js&"
export * from "./userTeamRankings.vue?vue&type=script&lang=js&"
import style0 from "./userTeamRankings.vue?vue&type=style&index=0&id=44341242&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44341242",
  null
  
)

export default component.exports